import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { Globals } from '../utils/globals';
/** Returns whether the document matches the given media query string */

export function useMatchMedia(
/** the media query to match on */
query) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      onMatchesChange = _ref.onMatchesChange,
      eventListenerOptions = _ref.eventListenerOptions;

  var _a;

  var _React$useState = React.useState(((_a = Globals.Window) === null || _a === void 0 ? void 0 : _a.matchMedia(query).matches) || false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isMatching = _React$useState2[0],
      setIsMatching = _React$useState2[1];

  var onMatchesChangeEvent = React.useCallback(function (event) {
    setIsMatching(event.matches);
    onMatchesChange === null || onMatchesChange === void 0 ? void 0 : onMatchesChange(event);
  }, [onMatchesChange]);
  React.useEffect(function () {
    var _a;

    var media = (_a = Globals.Window) === null || _a === void 0 ? void 0 : _a.matchMedia(query);

    if (!media) {
      return;
    }

    if (media.matches !== isMatching) {
      setIsMatching(media.matches);
    }

    media.addEventListener('change', onMatchesChangeEvent, eventListenerOptions);
    return function () {
      return media.removeEventListener('change', onMatchesChangeEvent, typeof eventListenerOptions === 'boolean' ? eventListenerOptions : eventListenerOptions && {
        capture: eventListenerOptions.capture
      });
    };
  }, [query, onMatchesChangeEvent]);
  return isMatching;
}